import { BlockReleaseTransformedResponse } from '@data/blockReleases/types/BlockRelease.types';
import { BlockReleaseState } from '@data/blockReleases/types/BlockReleaseState';

export const combineFlipReleases = (releases: BlockReleaseTransformedResponse[]): BlockReleaseTransformedResponse[] => {
	const groupedReleases: BlockReleaseTransformedResponse[] = [];

	releases.forEach((release) => {
		const releaseStart = new Date(release.startDateTime).getTime();
		const releaseEnd = new Date(release.endDateTime).getTime();

		let merged = false;

		for (const group of groupedReleases) {
			const groupStart = new Date(group.startDateTime).getTime();
			const groupEnd = new Date(group.endDateTime).getTime();

			// Check if the release date/time overlaps with the current group
			const overlap = Math.min(groupEnd, releaseEnd) - Math.max(groupStart, releaseStart) >= 60 * 1000;

			if (
				group.unitId === release.unitId &&
					group.npis.sort().join(',') === release.npis.sort().join(',') &&
					overlap
			) {
				// Merge the release into the group
				group.startDateTime = group.startDateTime < release.startDateTime ? group.startDateTime : release.startDateTime;
				group.endDateTime = group.endDateTime > release.endDateTime ? group.endDateTime : release.endDateTime;
				group.blockStartTime = group.blockStartTime < release.blockStartTime ? group.blockStartTime : release.blockStartTime;
				group.blockEndTime = group.blockEndTime > release.blockEndTime ? group.blockEndTime : release.blockEndTime;
				group.npis = Array.from(new Set([...group.npis, ...release.npis]));
				group?.originalReleases?.push(release);
				merged = true;
				break;
			}
		}

		if (!merged) {
			// Create a new group if no overlap is found
			groupedReleases.push({
				...release,
				originalReleases: [release],
			} as BlockReleaseTransformedResponse);
		}
	});

	return groupedReleases.map((group) => {
		if (group.originalReleases?.length === 1) {
			return {
				...group.originalReleases[0],
			};
		} else {
			return {
				...group,
				state: BlockReleaseState.FLIP_RECOMMENDATION,
			}
		}
	});
};
